export default __webpack_public_path__ + "static/media/logo.62174166.png";